import React, { Component } from 'react';

export class BookmarkBanner extends Component {
    state = {
        showCheck: true
    }

    closeCheck = () => {
        this.setState({
            showCheck: false
        });
    }

    render() {
        const bookmarkMessage = "This site is for authentication purposes only. <span> Please do not bookmark.</span>";
        return (
            <div>
                {this.state.showCheck &&
                    <div className="browser-site-status">
                        <div>
                            <div>
                                <img src="/images/icon-exclamation-circle-orange.svg" alt="alert icon" />
                                <div className="message" dangerouslySetInnerHTML={{ __html: bookmarkMessage }} ></div>
                            </div>
                        </div>
                        <div>
                            <img src="/images/x-gray.svg" onClick={this.closeCheck} alt="close icon" />
                        </div>
                    </div>
                }
            </div>
        );
    }
}